import script from "./PalettesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PalettesPage.vue?vue&type=script&setup=true&lang=js"

import "./PalettesPage.vue?vue&type=style&index=0&id=7f0666a1&lang=css"

const __exports__ = script;

export default __exports__